export { default } from './socialMedia'